import React, { SVGProps } from 'react';

export const ArrowRightIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 25,
  height = 8,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 25 8"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.3536 4.35355C24.5488 4.15829 24.5488 3.84171 24.3536 3.64645L21.1716 0.464466C20.9763 0.269204 20.6597 0.269204 20.4645 0.464466C20.2692 0.659728 20.2692 0.976311 20.4645 1.17157L23.2929 4L20.4645 6.82843C20.2692 7.02369 20.2692 7.34027 20.4645 7.53553C20.6597 7.7308 20.9763 7.7308 21.1716 7.53553L24.3536 4.35355ZM0 4.5H24V3.5H0V4.5Z"
        fill="#E9E9E9"
      />
    </svg>
  );
};
